import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {EmpresaService} from '../../services/empresa.service';

@Component({
  selector: 'app-form-integracao-ifood',
  templateUrl: './form-integracao-ifood.component.html',
  styleUrls: ['./form-integracao-ifood.component.scss']
})
export class FormIntegracaoIfoodComponent implements OnInit {
  readonly APP_IFOOD_CATALOGO = 'catalogo';
  readonly APP_IFOOD_LOGISTICA = 'logistica';
  readonly APP_IFOOD_PEDIDOS = 'pedidos';
  appIfoodSelecionado: string = null;
  @ViewChild('frm', {}) frm: any;
  @Input() empresa: any;
  @Input() integracaoIfood: any;
  @Input() ifooodUserCode: any = {};
  @Output() salvou = new EventEmitter<any>();
  @Output() cancelou = new EventEmitter<void>();
  mensagemErro: string;
  salvando = false;
  gerandoLink = false;

  constructor(private empresaService: EmpresaService) { }

  ngOnInit(): void {
    if(this.integracaoIfood?.ifooodUserCode)
      this.ifooodUserCode = this.integracaoIfood.ifooodUserCode;

    if(!this.ifooodUserCode) this.ifooodUserCode = {};
    this.sincronizeAppIfoodComApis();
  }

  async onSubmit(): Promise<void> {
    if(!this.frm.valid) return;

    if(!this.catalogApiAtiva())
      this.integracaoIfood.publicacaoCatalogoHabilitada = false;

    this.salvando = true;
    this.mensagemErro = null;
    try {
      let integracao: any;
      if(this.integracaoIfood.nova) {
        const dadosAutorizacao = {
          ...this.ifooodUserCode,
          orderApi: this.integracaoIfood.orderApi === true,
          shippingApi: this.integracaoIfood.shippingApi === true,
          publicacaoCatalogoHabilitada: this.integracaoIfood.publicacaoCatalogoHabilitada === true
        };
        integracao = await this.empresaService.autorizeNovaLoja(dadosAutorizacao);
        this.empresaService.sincronizeFormasPagamentoIfood().then(() => {}).catch(() => {});
      } else {
        integracao = await this.empresaService.atualizeIntegracaoIfood(this.integracaoIfood);
      }
      this.salvou.emit(integracao);
    } catch(erro) {
      this.mensagemErro = this.textoErro(erro);
    } finally {
      this.salvando = false;
    }
  }

  async gereLinkAutorizacao(): Promise<void> {
    this.gerandoLink = true;
    this.mensagemErro = null;
    const idLojaDigitado = this.ifooodUserCode.idLoja;
    try {
      this.ifooodUserCode = await this.empresaService.gereLinkAtivacaoIfood(this.appIfoodSelecionado);
      if(idLojaDigitado) this.ifooodUserCode.idLoja = idLojaDigitado;
    } catch(erro) {
      this.mensagemErro = this.textoErro(erro);
    } finally {
      this.gerandoLink = false;
    }
  }

  cancelar(): void {
    this.cancelou.emit();
  }

  fecharAlerta(): void {
    this.mensagemErro = null;
  }

  obrigarBandeiras(): boolean {
    return !this.empresa.exibirBandeiras &&
      (this.integracaoIfood.orderApi || this.integracaoIfood.shippingApi);
  }

  catalogApiAtiva(): boolean {
    return this.integracaoIfood != null && this.integracaoIfood.desativado !== true;
  }

  sincronizeAppIfoodComApis(): void {
    if(!this.integracaoIfood) return;

    if(this.integracaoIfood.nova) {
      if(this.ifooodUserCode?.id || this.ifooodUserCode?.clienteId) {
        this.appIfoodSelecionado = this.ifooodUserCode.clienteId
          ? this.APP_IFOOD_CATALOGO : this.APP_IFOOD_PEDIDOS;
        if(this.appIfoodSelecionado === this.APP_IFOOD_PEDIDOS)
          this.integracaoIfood.orderApi = true;
      }
      return;
    }

    if(this.integracaoIfood.orderApi) {
      this.appIfoodSelecionado = this.APP_IFOOD_PEDIDOS;
      return;
    }

    if(this.integracaoIfood.shippingApi) {
      this.appIfoodSelecionado = this.APP_IFOOD_LOGISTICA;
      return;
    }

    this.appIfoodSelecionado = this.APP_IFOOD_CATALOGO;
  }

  selecionarApp(app: string): void {
    if(!this.integracaoIfood.nova || this.ifooodUserCode?.id) return;
    this.appIfoodSelecionado = app;
    this.onSelecionarAppIfood();
  }

  onSelecionarAppIfood(): void {
    if(!this.integracaoIfood) return;

    if(this.appIfoodSelecionado === this.APP_IFOOD_CATALOGO) {
      this.integracaoIfood.orderApi = false;
      this.integracaoIfood.shippingApi = false;
      this.integracaoIfood.solicitarAutomatico = false;
      this.integracaoIfood.confirmarCotacao = false;
      return;
    }

    this.integracaoIfood.orderApi = true;
    if(this.appIfoodSelecionado === this.APP_IFOOD_LOGISTICA) {
      this.integracaoIfood.orderApi = false;
      this.integracaoIfood.shippingApi = true;
    }
  }

  descricaoApp(): string {
    if(this.appIfoodSelecionado === this.APP_IFOOD_CATALOGO) return 'Meu Cardápio — Catálogo';
    if(this.appIfoodSelecionado === this.APP_IFOOD_LOGISTICA) return 'Meu Cardápio — Delivery';
    return 'Meu Cardápio — Completo';
  }

  private textoErro(erro: any): string {
    return String(erro?.message || erro || 'Não foi possível salvar a integração.');
  }
}
